import React from "react";
import Badge from "@material-ui/core/Badge";
import { getTimeStringfromSeconds } from "../../functions";
import "./index.css";
const notification_gif = require("../../assets/media/headers/notification.gif");

const Ticket = ({ data, isNew, brand_data, onSelect }) => {
  let brand_name = "Brand";
  if (brand_data) brand_name = brand_data.name;
  return (
    <div
      className="block-content"
      style={{ background: "white" }}
      onClick={onSelect}
    >
      <div className="row_div">
        <p style={{ fontSize: 12 }}>
          <span style={{ fontWeight: "bold", color: "black" }}>
            {brand_name}
          </span>{" "}
          - Support ticket - {data.type}
        </p>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: 200,
          justifyContent: "space-between",
        }}
      ></div>

      {isNew && (
        <Badge color="secondary" variant="dot" invisible={false}>
          <img src={notification_gif} width="45" alt="notification_img" />
        </Badge>
      )}
      <span style={{ fontSize: 12 }}>
        {getTimeStringfromSeconds(data.time)}
      </span>
    </div>
  );
};
export default Ticket;



// WEBPACK FOOTER //
// ./src/screens/SuperSupport/Ticket.js